"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pagination.step': 'Passo',
    'onboarding.pagination.step.1': 'Passo 1',
    'onboarding.pagination.navigation': 'Navigazione Onboarding',
};
